import React from "react";
import {Switch} from 'react-router-dom';
import OnboardingScreen from "./pages/OnboardingScreen/OnboardingScreen";
import LandingPage from "./pages/LandingPage/LandingPage";
import Portfolio from "./pages/Portfolio/Portfolio";
import WalletLanding from "./pages/UserWallet/WalletLanding";
import ProfileVerification from "./pages/UserWallet/ProfileVerification";
import PartyDetail from "./pages/PartyDetail/PartyDetail";
import StockDetail from "./pages/StockDetail/StockDetail";
import Login from "./pages/Login/Login";
import {withRouter} from 'react-router-dom';
import {compose} from "redux";
import {connect} from "react-redux";
import Profile from "./pages/Profile/Profile";
import PlayInstruction from "./pages/UserWallet/PlayInstruction";
import WalletContactUs from "./pages/UserWallet/WalletContactUs";
import Settings from "./pages/UserWallet/Settings";
import TermsAndCondition from "./pages/UserWallet/TermsAndCondition";
import PrivacyPolicy from "./pages/UserWallet/PrivacyPolicy";
import AppNotification from "./pages/UserWallet/AppNotification";
import PollResult from "./pages/UserWallet/PollResult";
import InviteFriend from "./pages/UserWallet/InviteFriend";
import Collections from "./pages/UserWallet/Collections";
import WalletHistory from "./pages/UserWallet/WalletHistory";
import {PublicRoute, PrivateRoute} from "react-private-public-route";
import Payment from "./pages/UserWallet/Payment";
import NewsDetail from "./pages/NewsDetail/NewsDetail";
import AllStocks from "./pages/AllStocks/AllStocks";
import KycForm from "./pages/KycForm/KycForm";
import AllPastTransaction from "./pages/Portfolio/AllPastTransaction";
import ProfileDetail from "./pages/Profile/ProfileDetail";
import WalletProfileEdit from "./pages/UserWallet/WalletProfileEdit";
import ExtendedContentSubpage from "./pages/ExtendedContentSubPage/ExtendedContentSubpage";
import AllCollectionPage from "./pages/AllCollectionPage/AllCollectionPage";
import ScrollToTop from 'react-router-scroll-top';
import firebase from "./firebase";
import localStorage from "redux-persist/es/storage";
import {
	isIOS,
	isSafari,
	isMobileSafari,
} from "react-device-detect"
import Test from "./test";
import Home from "./pages/Home";

class Routes extends React.Component {
	// state = {
	// 	installButton:true
	// }
	//
	// installPrompt = null;
	// componentDidMount(){
	// 	console.log("Listening for Install prompt");
	// 	window.addEventListener('beforeinstallprompt',e=>{
	// 		// For older browsers
	// 		e.preventDefault();
	// 		console.log("Install Prompt fired");
	// 		this.installPrompt = e;
	// 		// See if the app is already installed, in that case, do nothing
	// 		if((window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) || window.navigator.standalone === true){
	// 			return false;
	// 		}
	// 		// Set the state variable to make button visible
	// 		this.setState({
	// 			installButton:true
	// 		})
	// 	})
	// }
	//
	// installApp=async ()=>{
	// 	if(!this.installPrompt) return false;
	// 	this.installPrompt.prompt();
	// 	let outcome = await this.installPrompt.userChoice;
	// 	if(outcome.outcome==='accepted'){
	// 		console.log("App Installed")
	// 	}
	// 	else{
	// 		console.log("App not installed");
	// 	}
	// 	// Remove the event reference
	// 	this.installPrompt=null;
	// 	// Hide the button
	// 	this.setState({
	// 		installButton:false
	// 	})
	// }

 	// componentDidMount() {
	// 	if(isIOS !== true && isSafari !== true && isMobileSafari !== true){
	// 		const msg  = firebase.messaging();
	// 		msg.requestPermission().then(()=>{
	// 			return msg.getToken();
	// 		}).then((data)=>{
	// 			localStorage.setItem("notification-token",data);
	// 		}).catch((error)=>{
	// 			// console.log(error);
	// 			localStorage.setItem("notification-token","");
	//
	// 		})
	// 	}
	// }




	render() {
		return (
			<div>
				<ScrollToTop>
					<Switch>
						<PublicRoute exact path='/test' component={Test}/>

						<PublicRoute exact path='/' component={Home}/>
						{/*<PublicRoute exact path="/login" component={Login}/>*/}
						{/*<PublicRoute exact path="/login/:id" component={Login}/>*/}
						<PublicRoute exact path="/home" component={LandingPage}/>
						<PublicRoute exact path="/all-stocks/:action" component={AllStocks}/>
						<PublicRoute exact path="/stock-detail/:id" component={StockDetail}/>
						<PublicRoute exact path="/portfolio" component={Portfolio}/>

						<PublicRoute exact path="/profile" component={Profile}/>
						<PublicRoute exact path="/profile-detail" component={ProfileDetail}/>
						<PublicRoute exact path="/all-collections" component={AllCollectionPage}/>
						<PublicRoute exact path="/all-stocks" component={AllStocks}/>
						<PublicRoute exact path="/party-detail/:id" component={PartyDetail}/>
						<PublicRoute exact path="/extend" component={ExtendedContentSubpage}/>
						<PublicRoute exact path="/news/:id" component={NewsDetail}/>

						<PublicRoute exact path="/terms-and-condition" component={TermsAndCondition}/>
						<PublicRoute exact path="/privacy-policy" component={PrivacyPolicy}/>
						<PublicRoute exact path="/collections" component={Collections}/>
						<PublicRoute exact path="/extend/:action" component={ExtendedContentSubpage}/>




						{/*<PrivateRoute*/}
						{/*	exact*/}
						{/*	path='/home'*/}
						{/*	isAuthenticated={this.props.logged_in}*/}
						{/*	redirect='/login'*/}
						{/*	component={LandingPage}*/}
						{/*/>*/}
						{/*<PrivateRoute*/}
						{/*	exact*/}
						{/*	path='/portfolio'*/}
						{/*	isAuthenticated={this.props.logged_in}*/}
						{/*	redirect='/login'*/}
						{/*	component={Portfolio}*/}
						{/*/>*/}
						<PrivateRoute
							exact
							path='/payment'
							isAuthenticated={this.props.logged_in}
							redirect='/home'
							component={Payment}
						/>
						{/*<PrivateRoute*/}
						{/*	exact*/}
						{/*	path='/party-detail/:id'*/}
						{/*	isAuthenticated={this.props.logged_in}*/}
						{/*	redirect='/login'*/}
						{/*	component={PartyDetail}*/}
						{/*/>*/}
						{/*<PrivateRoute*/}
						{/*	exact*/}
						{/*	path='/stock-detail/:id'*/}
						{/*	isAuthenticated={this.props.logged_in}*/}
						{/*	redirect='/login'*/}
						{/*	component={StockDetail}*/}
						{/*/>*/}
						{/*<PrivateRoute*/}
						{/*	exact*/}
						{/*	path='/news/:id'*/}
						{/*	isAuthenticated={this.props.logged_in}*/}
						{/*	redirect='/login'*/}
						{/*	component={NewsDetail}*/}
						{/*/>*/}
						<PrivateRoute
							exact
							path='/kyc'
							isAuthenticated={this.props.logged_in}
							redirect='/home'
							component={KycForm}
						/>
						{/*<PrivateRoute*/}
						{/*	exact*/}
						{/*	path='/profile'*/}
						{/*	isAuthenticated={this.props.logged_in}*/}
						{/*	redirect='/login'*/}
						{/*	component={Profile}*/}
						{/*/>*/}
						{/*<PrivateRoute*/}
						{/*	exact*/}
						{/*	path='/profile-detail'*/}
						{/*	isAuthenticated={this.props.logged_in}*/}
						{/*	redirect='/login'*/}
						{/*	component={ProfileDetail}*/}
						{/*/>*/}
						<PrivateRoute
							exact
							path='/wallet'
							isAuthenticated={this.props.logged_in}
							redirect='/home'
							component={WalletLanding}
						/>
						<PrivateRoute
							exact
							path='/profile-verification'
							isAuthenticated={this.props.logged_in}
							redirect='/home'
							component={ProfileVerification}
						/>
						<PrivateRoute
							exact
							path='/how-to-play'
							isAuthenticated={this.props.logged_in}
							redirect='/home'
							component={PlayInstruction}
						/>
						<PrivateRoute
							exact
							path='/contact-us'
							isAuthenticated={this.props.logged_in}
							redirect='/home'
							component={WalletContactUs}
						/>
						<PrivateRoute
							exact
							path='/setting'
							isAuthenticated={this.props.logged_in}
							redirect='/home'
							component={Settings}
						/>
						{/*<PrivateRoute*/}
						{/*	exact*/}
						{/*	path='/terms-and-condition'*/}
						{/*	isAuthenticated={this.props.logged_in}*/}
						{/*	redirect='/login'*/}
						{/*	component={TermsAndCondition}*/}
						{/*/>*/}
						{/*<PrivateRoute*/}
						{/*	exact*/}
						{/*	path='/privacy-policy'*/}
						{/*	isAuthenticated={this.props.logged_in}*/}
						{/*	redirect='/login'*/}
						{/*	component={PrivacyPolicy}*/}
						{/*/>*/}
						<PrivateRoute
							exact
							path='/notification'
							isAuthenticated={this.props.logged_in}
							redirect='/home'
							component={AppNotification}
						/>
						<PrivateRoute
							exact
							path='/poll-result'
							isAuthenticated={this.props.logged_in}
							redirect='/home'
							component={PollResult}
						/>
						<PrivateRoute
							exact
							path='/invite'
							isAuthenticated={this.props.logged_in}
							redirect='/home'
							component={InviteFriend}
						/>
						{/*<PrivateRoute*/}
						{/*	exact*/}
						{/*	path='/collections'*/}
						{/*	isAuthenticated={this.props.logged_in}*/}
						{/*	redirect='/login'*/}
						{/*	component={Collections}*/}
						{/*/>*/}
						<PrivateRoute
							exact
							path='/past-transaction'
							isAuthenticated={this.props.logged_in}
							redirect='/home'
							component={AllPastTransaction}
						/>
						<PrivateRoute
							exact
							path='/wallet-history'
							isAuthenticated={this.props.logged_in}
							redirect='/home'
							component={WalletHistory}
						/>
						<PrivateRoute
							exact
							path='/wallet-profile-edit'
							isAuthenticated={this.props.logged_in}
							redirect='/home'
							component={WalletProfileEdit}
						/>
						{/*<PrivateRoute*/}
						{/*	exact*/}
						{/*	path='/all-stocks'*/}
						{/*	isAuthenticated={this.props.logged_in}*/}
						{/*	redirect='/login'*/}
						{/*	component={AllStocks}*/}
						{/*/>*/}
						{/*<PrivateRoute*/}
						{/*	exact*/}
						{/*	path='/all-stocks/:action'*/}
						{/*	isAuthenticated={this.props.logged_in}*/}
						{/*	redirect='/login'*/}
						{/*	component={AllStocks}*/}
						{/*/>*/}
						{/*<PrivateRoute*/}
						{/*	exact*/}
						{/*	path='/extend'*/}
						{/*	isAuthenticated={this.props.logged_in}*/}
						{/*	redirect='/login'*/}
						{/*	component={ExtendedContentSubpage}*/}
						{/*/>*/}
						{/*<PrivateRoute*/}
						{/*	exact*/}
						{/*	path='/extend/:action'*/}
						{/*	isAuthenticated={this.props.logged_in}*/}
						{/*	redirect='/login'*/}
						{/*	component={ExtendedContentSubpage}*/}
						{/*/>*/}
						{/*<PrivateRoute*/}
						{/*	exact*/}
						{/*	path='/all-collections'*/}
						{/*	isAuthenticated={this.props.logged_in}*/}
						{/*	redirect='/login'*/}
						{/*	component={AllCollectionPage}*/}
						{/*/>*/}

					</Switch>
				</ScrollToTop>
			</div>
		);
	}
}

const mapStateToProps = state => ({
	user_details: state.UserReducer.user_details,
	logged_in: state.UserReducer.logged_in
});

export default compose(
	withRouter,
	connect(
		mapStateToProps,
		null
	)
)(Routes);
